import React, {Component} from 'react';
import '../App.css';


import Header from './Header.js';
import Calendar from './Calendar.js';
import Detail from './Detail.js';


import {
    BrowserRouter as Router,
    Route,
    Redirect
} from 'react-router-dom'

class MainApp extends Component {


    render() {
        return (
            <div className="content" ref={'content'}>

                <Header main={this}/>


                <Router ref={'router'}>
                    <div>
                        <Route exact path="/:language" render={(route) => <Calendar route={route} main={this}/>}/>
                        <Route path="/:language/:rif" render={(route) => <Detail route={route} main={this}/>}/>
                        <Route exact path="/" render={() => (<Redirect to={"/" + this.props.main.language} />)} />
                    </div>
                </Router>


            </div>
        );
    }
}

export default MainApp;




// WEBPACK FOOTER //
// ./src/include/MainApp.js